// @services/clients/AuthenticationClient.ts
import type { AuthenticationClient as InteropAuthenticationClient } from '@ps-bridge/clients/authentication';
import type {
    AuthenticationError,
    CreateAccountRequest,
    JwtResponse,
    LoginRequest,
    PasswordResetCompleteRequest,
    PasswordResetError,
    PasswordResetStartRequest,
} from '@ps-bridge/models/core/dataContracts';
import type { EffectTs } from '@ps-bridge/interop';
import { effectFromRaw } from '@utils/effects/branded';
import type { Ok } from '@ps-bridge/ok';

export interface AuthenticationClient {
    readonly createAccount: (request: CreateAccountRequest) => EffectTs<Ok, AuthenticationError>;
    readonly login: (request: LoginRequest) => EffectTs<string, AuthenticationError>;
    readonly refreshJwtToken: EffectTs<JwtResponse, AuthenticationError>;
    readonly logout: EffectTs<Ok, AuthenticationError>;
    readonly requestPasswordReset: (request: PasswordResetStartRequest) => EffectTs<Ok, PasswordResetError>;
    readonly completePasswordReset: (
        request: PasswordResetCompleteRequest,
    ) => EffectTs<Ok, PasswordResetError>;
}

export const fromInteropAuthenticationClient = (client: InteropAuthenticationClient): AuthenticationClient => ({
    createAccount: (request) => effectFromRaw(client.createAccount(request)),
    login: (request) => effectFromRaw(client.login(request)),
    refreshJwtToken: effectFromRaw(client.refreshJwtToken),
    logout: effectFromRaw(client.logout),
    requestPasswordReset: (request) => effectFromRaw(client.requestPasswordReset(request)),
    completePasswordReset: (request) => effectFromRaw(client.completePasswordReset(request)),
});
